import { useEffect, useRef, useState } from 'react';

export default function useBraintree({
  pkBraintree,
  onCardTypeChange,
  onValidityChange,
  onBlur,
  onFocus,
}: {
  pkBraintree: string;
  onCardTypeChange: Function;
  onValidityChange: Function;
  onBlur: Function;
  onFocus: Function;
}) {
  function load_braintree() {
    window['braintree'].client
      .create({
        authorization: pkBraintree,
      })
      .then(function (clientInstance) {
        window['braintree'].dataCollector.create({
          client: clientInstance,
          paypal: true
        }, function (dataCollectorErr, dataCollectorInstance) {
          if (dataCollectorErr) {
            // Handle error in creation of data collector.
            return;
          }
          // At this point, you should access the dataCollectorInstance.deviceData value and provide it
          // to your server, e.g. by injecting it into your form as a hidden input.
          deviceData.current = dataCollectorInstance.deviceData;
        });

        // Create a PayPal Checkout component.
        return window['braintree'].hostedFields.create({
          client: clientInstance,
          fields: {
            number: {
              container: '#card-number',
              placeholder: 'Card Number',
            },
            cvv: {
              container: '#cvv',
              placeholder: 'CVV',
            },
            expirationDate: {
              container: '#expiration-date',
              placeholder: 'MM/YY',
            },
            postalCode: {
              container: '#postal-code',
              placeholder: 'ZIP / Postal Code',
            },
          },
          styles: {
            input: {
              'font-size': 'inherited',
              'font-family': 'roboto, verdana, sans-serif',
              color: 'black',
            },
            ':focus': {
              color: 'black',
            },
            '.valid': {
              color: 'black',
            },
            '.invalid': {
              color: 'red',
            },
          },
        });
      })
      .then(function (hostedFieldsInstance) {
        hostedFieldsInstance.on('cardTypeChange', (e) => onCardTypeChange(e));
        hostedFieldsInstance.on('validityChange', (e) => onValidityChange(e));
        hostedFieldsInstance.on('blur', (e) => onBlur(e));
        hostedFieldsInstance.on('focus', (e) => onFocus(e));
        tokenize.current = () => {
          return new Promise((resolve, reject) => {
            hostedFieldsInstance.tokenize(function (err, payload) {
              if (err) reject(err);
              resolve(payload);
            });
          });
        };
        clearFields.current = () => {
          hostedFieldsInstance.clear('number');
          hostedFieldsInstance.clear('cvv');
          hostedFieldsInstance.clear('expirationDate');
          hostedFieldsInstance.clear('postalCode');
        };
      })
      .catch(function (err) {
        // Handle component creation error
      });
  }
  const tokenize = useRef(() => { ; });
  const deviceData = useRef(() => { ; });
  const clearFields = useRef(() => { ; });
  useEffect(() => {
    (function load() {
      if (!pkBraintree) return;
      if (
        window['braintree'] &&
        window['braintree'].dataCollector &&
        window['braintree'].client &&
        document.getElementById('card-number') != null &&
        document.getElementById('cvv') != null &&
        document.getElementById('expiration-date') != null &&
        document.getElementById('postal-code') != null
      ) {
        load_braintree();
      } else {
        setTimeout(load, 300);
      }
    })();
  }, []);
  return [tokenize, deviceData, clearFields];
}

